import { assertNotOptional } from '@wix/seo-common-core';
import React, { createContext, useContext, useMemo } from 'react';
const DuplexerContext = /*#__PURE__*/createContext(null);
export const DuplexerProvider = _ref => {
  let {
    duplexerData: duplexerDataFromProps,
    initDuplexer,
    signedInstance,
    children
  } = _ref;
  const duplexerData = useMemo(() => {
    if (!signedInstance) {
      return null;
    }
    if (duplexerDataFromProps) {
      return duplexerDataFromProps;
    }
    assertNotOptional(initDuplexer);
    return initDuplexer(signedInstance);
  }, [signedInstance, duplexerDataFromProps, initDuplexer]);
  return /*#__PURE__*/React.createElement(DuplexerContext.Provider, {
    value: duplexerData
  }, children);
};
export const useDuplexerContext = () => {
  const context = useContext(DuplexerContext);
  return context ?? {};
};
//# sourceMappingURL=use-duplexer-context.js.map